import React from "react";
import { NavLink } from "react-router-dom";
import FooterLogo from "../Img/Brand-logo-footer.png";
import { FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import Linkedin from "../Img/Final-images/linkedin.png";
import { CiLinkedin } from "react-icons/ci";

function Footer() {
  const scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 100);
  };

  // ✅ Better mailto handler (more reliable)
  const handleEmailClick = () => {
    const subject = encodeURIComponent("Job Inquiry");
    const body = encodeURIComponent(
      "Hello Team,\n\nI am interested in your services.\n\nThanks & Regards",
    );

    window.location.href = `mailto:info@affinitychildrens.co.uk?subject=${subject}&body=${body}`;
  };

  return (
    <footer className="footer">
      <section>
        <div className="footer-container">
          {/* Column 1 */}
          <div className="footer-col">
            <h4>About Us</h4>
            <p className="text-white">
              Affinity Childrens Services Ltd was established in 2022. It
              provides social care solutions across multiple areas.
            </p>

            <NavLink to="/about" onClick={scrollToTop}>
              Read More
            </NavLink>
          </div>

          {/* Column 2 */}
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <NavLink to="/" onClick={scrollToTop}>
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/about" onClick={scrollToTop}>
                  About Affinity
                </NavLink>
              </li>

              <li>
                <NavLink to="/ourapproch" onClick={scrollToTop}>
                  Our Approch
                </NavLink>
              </li>

              <li>
                <NavLink to="/ourhome" onClick={scrollToTop}>
                  Our Homes
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" onClick={scrollToTop}>
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Column 3 */}
          <div className="footer-col">
            <h4>Contact</h4>

            {/* ✅ FIXED EMAIL CLICK */}
            <p className="text-white">
              <FaEnvelope />{" "}
              <span
                className="email-link"
                onClick={handleEmailClick}
                style={{ cursor: "pointer", textDecoration: "underline" }}
              >
                info@affinitychildrens.co.uk
              </span>
            </p>

            <p className="text-white">
              <FaMapMarkerAlt /> The Old Coach House, Horse Fair, Rugeley,
              Staffordshire, England WS15 2EL
            </p>
          </div>

          {/* Column 4 */}
          <div className="footer-col footer-logo">
            <img src={FooterLogo} alt="Logo" />
            <p className="text-white">© 2025 Affinity Childrens Services LTD</p>
            <span className="rounded-pill py-2 text-white">
              <a
                href="https://www.linkedin.com/company/affinity-childrens-services-ltd/"
                target="_blank"
                className="social-icon_L"
              >
                <CiLinkedin />
              </a>
            </span>
          </div>
        </div>
      </section>
    </footer>
  );
}

export default Footer;
